import { Header } from "@/components/layout/header";
import { Main } from "@/components/layout/main";
import { Button } from "@/components/ui/button";
import { useAuthStore } from "@/stores/auth";
import { LogOut } from "lucide-react";
import { Outlet } from "react-router-dom";

const LeavePage: React.FC = () => {
    const { logout } = useAuthStore();
    return (
        <>
            <Header fixed className='flex justify-between w-[inherit]'>
                <div className='mr-0 flex items-center justify-end space-x-4 w-[inherit]'>
                    <Button variant="outline" size="icon" onClick={logout}>
                        <LogOut />
                    </Button>
                </div>
            </Header>

            <Main>
                <h4 className="text-2xl font-bold">Leave</h4>

                <Outlet />
            </Main>
        </>
    )
}

export default LeavePage;